<template>
  <v-container fluid class="hyp-table-container">
    <v-row>
      <v-col>
        <v-data-table
          v-resize="this.handleResize"
          :headers="headers"
          :items="assets"
          :items-per-page="itemsPerPage"
          :search="search"
          sort-by="title"
          :height="listingHeight"
          fixed-header
          :loading="loading"
          loading-text="Retrieving assets"
          class="assets-data-table"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search My Places"
                  single-line
                  hide-details
                  class="ml-4"
                  style="width: 450px;"
                >
                </v-text-field>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-dialog
                v-model="dialog"
                max-width="1000px"
                content-class="asset-dialog"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    small
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                    v-on:click="addItem"
                  >
                    Add New Place
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <v-row>
                      <v-col>
                        <span>{{ formTitle }}</span>
                      </v-col>
                      <v-col cols="1">
                        <v-icon right v-on:click="close">mdi-close</v-icon>
                      </v-col>
                    </v-row>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="validForm">
                        <v-row>
                          <v-col cols="6">
                            <v-text-field
                              v-model="asset.title"
                              :counter="100"
                              label="Asset name"
                              :rules="nameRules"
                              required
                            ></v-text-field>
                            <v-text-field
                              v-model.number="asset.location.latitude"
                              type="number"
                              step="any"
                              :rules="latitudeRules"
                              label="Latitude"
                              required
                            ></v-text-field>
                            <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              :return-value.sync="asset.expirationDate"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="asset.expirationDate"
                                  label="Expiration Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="asset.expirationDate"
                                no-title
                                scrollable
                                :show-current="utcDate"
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu.save(asset.expirationDate)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="6">
                            <v-select
                              v-model="asset.assetType.id"
                              :items="assetTypes"
                              item-text="name"
                              item-value="assetTypeId"
                              label="Asset Type"
                              return-object
                              single-line
                              required
                            ></v-select>
                            <v-text-field
                              v-model.number="asset.location.longitude"
                              type="number"
                              step="any"
                              :rules="longitudeRules"
                              label="Longitude"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-divider></v-divider>
                        </v-row>
                        <!-- Dynamically display custom fields -->
                        <v-row>
                          <v-col
                            cols="6"
                            v-for="(field, index) in assetCustomFields"
                            v-bind:key="index"
                          >
                            <v-textarea
                              :value="
                                asset.customFields[
                                  `${field.name.toLowerCase()}`
                                ]
                              "
                              :label="field.name"
                              :rows="1"
                              auto-grow
                              :counter="750"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <AssetsEditor
                              :asset="asset"
                              @change="handleOnChange"
                            ></AssetsEditor>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text class="default btn mr-5" @click="close">
                      Cancel
                    </v-btn>
                    <v-btn
                      class="primary btn mr-3"
                      @click="save"
                      :disabled="!validForm"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title>
                    Are you sure you want to delete {{ asset.title }}?
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="default" text @click="closeDelete"
                      >Cancel</v-btn
                    >
                    <v-btn class="primary" text @click="deleteItemConfirm"
                      >OK</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
              Reset
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  getAssetsByUserGroup,
  getAssetTypesByUserGroup,
  getCustomFieldsByUserGroup,
} from "@/services/assetManagement/assets.service";
import { forEach } from "lodash";
import camelCase from "lodash/camelCase";
import { ASSET_CUSTOM_AOI } from "@/common/constants/assetManagement";
import { mapGetters } from "vuex";
import { MODULE_PREFIX_TIME } from "@/store";
export default {
  name: "AssetsList",
  components: {
    AssetsEditor: () => import("@/components/assetManagement/AssetsEditor"),
  },
  data() {
    return {
      validForm: false,
      assetSelected: null,
      customFields: getCustomFieldsByUserGroup(),
      initialHeaders: [
        { text: "Actions", value: "action", sortable: false },
        { text: "Title", value: "title", sortable: true, width: 250 },
        {
          text: "Asset Type",
          value: "assetType.name",
          sortable: true,
          width: 175,
        },
      ],
      finalHeaders: [
        { text: "Latitude", value: "location.latitude", sortable: false },
        { text: "Longitude", value: "location.longitude", sortable: false },
      ],
      itemsPerPage: 10,
      loading: false,
      search: null,
      windowSize: {
        x: 0,
        y: 0,
      },
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      emptyAsset: {
        title: "",
        assetType: {
          color: "",
          icon: "",
          id: null,
          name: "",
        },
        location: {
          latitude: 0,
          longitude: 0,
        },
        isSystemType: false,
        enabled: false,
        customFields: {},
        expirationDate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
      },
      asset: {
        title: "",
        assetType: {
          color: "",
          icon: "",
          id: null,
          name: "",
        },
        location: {
          latitude: null,
          longitude: null,
        },
        isSystemType: false,
        enabled: false,
        customFields: {},
        expirationDate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
      },
      nameRules: [
        (value) => !!value || "Required.",
        (value) => (value || "").length <= 100 || "Max 100 characters",
      ],
      latitudeRules: [
        (value) => !!value || "Required.",
        (value) => value >= -90 || "Greater than -90",
        (value) => value <= 90 || "Less than 90",
      ],
      longitudeRules: [
        (value) => !!value || "Required.",
        (value) => value >= -180 || "Greater than -180",
        (value) => value <= 180 || "Less than 180",
      ],
      assetTypes: getAssetTypesByUserGroup(),
      assetCustomFields: getCustomFieldsByUserGroup(),
      aoiFeature: ASSET_CUSTOM_AOI,
      menu: false,
    };
  },
  computed: {
    ...mapGetters({
      utcDate: MODULE_PREFIX_TIME + "today",
    }),
    listingHeight() {
      return this.windowSize.y - 350;
    },
    headers() {
      let headers = [];
      forEach(this.customFields, (field) => {
        const name = field.name;
        headers.push({
          text: name,
          value: `customFields[` + camelCase(name) + `]`,
          sortable: true,
          width: 200,
        });
      });
      return this.initialHeaders.concat(...headers, this.finalHeaders);
    },
    assets() {
      return getAssetsByUserGroup();
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Place" : "Edit Place";
    },
  },
  methods: {
    handleResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    addItem() {
      this.asset = Object.assign({}, this.emptyAsset);
    },
    editItem(item) {
      this.editedIndex = this.assets.indexOf(item);
      this.asset = item;
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.assets.indexOf(item);
      this.asset = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.assets.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.reset();
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.reset();
        this.editedIndex = -1;
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.editedIndex > -1) {
        Object.assign(this.assets[this.editedIndex], this.asset);
      } else {
        this.assets.push(this.asset);
      }
      this.close();
    },
    handleOnChange(aoiFeature) {
      if (
        aoiFeature?.geometry?.coordinates &&
        Array.isArray(aoiFeature.geometry.coordinates) &&
        aoiFeature.geometry.coordinates.length
      ) {
        this.asset.location.longitude = aoiFeature.geometry.coordinates[0].toFixed(
          4
        );
        this.asset.location.latitude = aoiFeature.geometry.coordinates[1].toFixed(
          4
        );
      }
    },
    reset() {
      this.asset = this.emptyAsset;
      this.$refs.form.reset();
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style>
.assets-data-table .v-data-table-header__icon {
  position: relative;
  top: -2px;
  left: 7px;
}
</style>

<style scoped>
.hyp-table-container {
  width: 1200px;
}
.assets-data-table {
  overflow-y: auto;
}
.assets-modify-button {
  position: absolute;
}
.v-data-table {
  overflow-x: auto;
}
>>> .asset-dialog {
  align-self: flex-end;
}
</style>
